import type { Chain } from "~/tools/chain";
import type { Defaultable } from "~/tools/defaultable";
import type { Functor } from "~/tools/functor";
import { Matchable } from "~/tools/matchable";

class Loading extends Matchable<"loading"> implements Functor<never>, Chain<never>, Defaultable<never> {
	protected readonly __name = "loading" as const;

	public isIdle(): false {
		return false;
	}

	public isLoading(): this is Loading {
		return true;
	}

	public isFailure(): false {
		return false;
	}

	public isSuccess(): false {
		return false;
	}

	public getOrElse<TFallback>(fallback: TFallback): TFallback {
		return fallback;
	}

	public transform(): this {
		return this;
	}

	public transformFailure(): this {
		return this;
	}

	public chain(): this {
		return this;
	}
}

export { Loading };
